/*global Stripe*/
import Marty from "marty";
import GATEWAY_CONSTANTS from "../constants/gatewayConstants";
import qs from "querystring";
import ApiError from "../utils/ApiError";
import assign from "object-assign";
import getFormErrors from "../utils/functions/getFormErrors";

let gatewayActions = Marty.createActionCreators({
    charge(data, reset, invalidate) {
        this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TOKEN_STARTING, true);
        Stripe.card.createToken(data.cardData, (status, token) => {
            if (status < 300 && status >= 200) {
                this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TOKEN_DONE, token);
                this.createTransaction(assign({token}, data), reset, invalidate);
            } else {
                let err = new ApiError("Error creating stripe token", token);

                this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TOKEN_FAILED, err);
                invalidate(getFormErrors(err.data));
            }
        });
    },
    createTransaction(data, reset, invalidate) {
        this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TRANSACTION_STARTING);
        this.app.gatewayAPI.createTransaction(data.token, data.customerData, data.shopifyData, data.urls.complete).then(res => {
            this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TRANSACTION_DONE, res.data);
            if (Marty.isBrowser) {
                const url = `${data.urls.complete}?${qs.stringify(res.data)}`;

                setTimeout(() => location.href = url, 2000);
                //location.href = url;
            }
        }).catch(err => {
            this.dispatch(GATEWAY_CONSTANTS.STRIPE_CREATE_TRANSACTION_FAILED, err);
            invalidate(getFormErrors(err.data));
        });
    },
    clearError() {
        this.dispatch(GATEWAY_CONSTANTS.STRIPE_SET_ERROR);
    },
    shopifyCallback(url, redirect, transaction, counter) {
        counter = counter || 0;

        this.dispatch(GATEWAY_CONSTANTS.SHOPIFY_CALLBACK_STARTING);
        if (Marty.isBrowser) {
            window.location = `${redirect}?${qs.stringify(transaction)}`;
        }
    }
});

export default gatewayActions;



/** WEBPACK FOOTER **
 ** ./app/actions/gatewayActions.js
 **/